/**
 * Want to add more text? Go to custom/classes/calendar-text and add new properties there.
 */
export interface IAddOnsAppBaseSettings {
    configId: number
    // Not from api but ~about~ api
    requesting: boolean;
    useUnseatedReservation: boolean;
    apiError: any;
    smartSeatUrl: string;
}


export const defaultBaseSettings: IAddOnsAppBaseSettings = {
    configId: 0,
    useUnseatedReservation: false,
    requesting: false,
    apiError: null,
    smartSeatUrl: ""
}